import { Pipe, PipeTransform } from '@angular/core';
import { WaHelperService } from '../../../wa-services/wa-helper-service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { filter, map, tap } from 'rxjs/operators';
import { CountryCombo } from '../../../../common-page-components/stores/filters-store/filters-store';

@Pipe({
  name: 'countryName'
})
export class CountryNamePipe implements PipeTransform {

  countryStore = new CountryCombo('', '', this.http, [], undefined, false, false);

  transform(value: string, args?: any): any {
    return this.getNameCountry(value);
  }
  private getNameCountry(country: string) {
    return this.countryStore.dataStream.pipe(
      filter(a => a != null && a.length > 0),
      map(a=>{
        return a.find(value=> value.NOC === country)
      })
    );
  }
  constructor(public http: HttpClient) {
  }
}
